<div class="vf-time-overlay" *ngIf="isOpen" [style.width.px]="modalWidth">

    <!-- Header -->
    <div class="d-flex align-items-center gap-8 px-12 py-12 flex-shrink-0" style="border-bottom: 1px solid rgb(229, 231, 235);">
        <button type="button" class="btn d-flex align-items-center justify-content-center text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-sm transition-colors flex-shrink-0 border-0 p-0"
            style="width: 28px; height: 28px; background: transparent;"
            (click)="onClose()" title="Back to details">
            <lucide-icon name="chevron-left" [size]="16" [strokeWidth]="2"></lucide-icon>
        </button>
        <span class="f-size-14 text-gray-900 flex-1">Time</span>
        <span class="f-size-12 text-gray-500 flex-shrink-0 mr-1" style="font-variant-numeric: tabular-nums;">{{ totalTime }}</span>
    </div>

    <!-- Toolbar -->
    <div class="d-flex align-items-center gap-04 px-12 py-8 flex-shrink-0" style="border-bottom: 1px solid rgb(229, 231, 235); background: rgb(252, 252, 252);">
        <button type="button" class="btn d-flex align-items-center gap-4 px-06 py-02 h-20 f-size-12 text-gray-500 hover:bg-gray-100 rounded-sm transition-colors border-0"
            style="background: transparent;" [disabled]="showAddForm"
            (click)="openAddForm()">
            <lucide-icon name="plus" [size]="14" [strokeWidth]="2"></lucide-icon>
            <span class="line-height-normal">Add entry</span>
        </button>
        <div class="bg-gray-200 mx-2 flex-shrink-0" style="width: 1px; height: 14px;"></div>
        <div class="position-relative">
            <button type="button" class="btn d-flex align-items-center gap-4 px-06 py-02 f-size-12 rounded-sm transition-colors border-0"
                [class.text-gray-500]="activeFilterCount === 0"
                [class.hover:bg-gray-100]="activeFilterCount === 0"
                [class.text-blue-600]="activeFilterCount > 0"
                [class.bg-blue-50]="activeFilterCount > 0"
                [class.hover:bg-blue-100]="activeFilterCount > 0"
                [style.background]="activeFilterCount > 0 ? '#eff6ff' : 'transparent'"
                (click)="toggleFilterPopover()">
                <lucide-icon name="funnel" [size]="14" [strokeWidth]="2"></lucide-icon>
                <span>Filter</span>
                <span *ngIf="activeFilterCount > 0"
                    class="d-inline-flex align-items-center justify-content-center px-1 text-white bg-blue-600 rounded-pill tabular-nums"
                    style="min-width: 16px; height: 16px; font-size: 10px; line-height: 1;">{{ activeFilterCount }}</span>
            </button>
            <!-- Filter popover -->
            <div class="vf-time-filter-popover" *ngIf="showFilterPopover" (click)="$event.stopPropagation()">
                <!-- Person section -->
                <div class="vf-time-filter-section">
                    <p class="vf-time-filter-section-label">Person</p>
                    <div class="d-flex flex-wrap gap-1-5">
                        <button type="button"
                            class="vf-time-filter-pill"
                            [class.vf-time-filter-pill--active]="isAllPersonsSelected"
                            (click)="selectAllPersons()">All</button>
                        <button *ngFor="let p of filterPeopleOptions" type="button"
                            class="vf-time-filter-pill"
                            [class.vf-time-filter-pill--active]="isPersonSelected(p.id)"
                            (click)="togglePersonFilter(p.id)">{{ p.name }}</button>
                    </div>
                </div>

                <!-- Date range section -->
                <div class="vf-time-filter-section">
                    <p class="vf-time-filter-section-label">Date range</p>
                    <div class="mb-8">
                        <p class="f-size-12 text-gray-500 mb-2 select-none">From</p>
                        <div class="vf-time-pill" (click)="openFilterFromPicker()">
                            <lucide-icon name="calendar" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                            <span class="flex-1 text-truncate f-size-13"
                                [class.text-gray-700]="filterDateFrom" [class.text-gray-400]="!filterDateFrom">
                                {{ filterDateFrom ? formatFilterDateDisplay(filterDateFrom) : 'Select date' }}
                            </span>
                            <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                            <input type="text" readonly autocomplete="off"
                                class="vf-time-overlay-input"
                                [id]="getFilterFromPickerId()">
                        </div>
                    </div>
                    <div>
                        <p class="f-size-12 text-gray-500 mb-2 select-none">To</p>
                        <div class="vf-time-pill" (click)="openFilterToPicker()">
                            <lucide-icon name="calendar" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                            <span class="flex-1 text-truncate f-size-13"
                                [class.text-gray-700]="filterDateTo" [class.text-gray-400]="!filterDateTo">
                                {{ filterDateTo ? formatFilterDateDisplay(filterDateTo) : 'Select date' }}
                            </span>
                            <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                            <input type="text" readonly autocomplete="off"
                                class="vf-time-overlay-input"
                                [id]="getFilterToPickerId()">
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <div class="d-flex align-items-center justify-content-between px-12 py-2">
                    <button type="button"
                        class="btn h-32 px-12 f-size-13 text-gray-500 hover:bg-gray-100 rounded-sm transition-colors border-0 bg-transparent"
                        [disabled]="!hasActiveFilterDraft"
                        (click)="clearFilter()">Clear all</button>
                    <button type="button"
                        class="btn h-32 px-12 f-size-13 text-white bg-gray-900 hover:bg-gray-700 rounded-sm transition-colors border-0"
                        (click)="applyFilter()">Done</button>
                </div>
            </div>
            <div *ngIf="showFilterPopover" class="vf-filter-backdrop" (click)="closeFilterPopover()"></div>
        </div>
    </div>

    <!-- Scrollable content -->
    <div class="vf-time-overlay__body">

        <!-- Loading skeleton -->
        <div *ngIf="isLoading">
            <div class="d-flex align-items-center justify-content-between px-16 py-8"
                style="border-bottom: 1px solid rgb(229, 231, 235); background: rgb(243, 244, 246);">
                <div class="skeleton-shimmer" style="height: 12px; width: 60px;"></div>
                <div class="skeleton-shimmer" style="height: 12px; width: 40px;"></div>
            </div>
            <div *ngFor="let s of [1,2,3,4]"
                class="px-16 py-12 d-flex align-items-center gap-12"
                style="border-bottom: 1px solid rgb(243, 244, 246);">
                <div class="d-flex align-items-center gap-8 flex-shrink-0" style="min-width: 108px;">
                    <div class="skeleton-shimmer" style="width: 24px; height: 24px; border-radius: 50%;"></div>
                    <div class="skeleton-shimmer" style="height: 12px; width: 72px;"></div>
                </div>
                <div class="skeleton-shimmer flex-1" style="height: 12px; max-width: 140px;"></div>
                <div class="skeleton-shimmer flex-shrink-0" style="height: 12px; width: 40px;"></div>
                <div class="skeleton-shimmer flex-shrink-0" style="width: 24px; height: 24px; border-radius: 4px;"></div>
            </div>
        </div>

        <ng-container *ngIf="!isLoading">

            <!-- Add entry inline form -->
            <div *ngIf="showAddForm" class="vf-time-form" style="background: rgb(249, 250, 251); border-bottom: 1px solid rgb(229, 231, 235);">

                <!-- Date (Litepicker) -->
                <div class="px-16 pt-12 pb-3">
                    <div class="vf-time-pill" (click)="openDatePicker()">
                        <lucide-icon name="calendar" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                        <input type="text" readonly autocomplete="off"
                            class="vf-time-pill-text-input flex-1 f-size-13"
                            [id]="getDatePickerElementId()"
                            placeholder="Select date">
                        <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                    </div>
                </div>

                <!-- Person picker -->
                <div class="px-16 pb-3">
                    <ng-container *ngTemplateOutlet="personPicker"></ng-container>
                </div>

                <!-- Time range -->
                <div class="d-flex align-items-center gap-8 px-16 pb-3">
                    <!-- Start time -->
                    <div class="flex-1 min-w-0 position-relative">
                        <div class="vf-time-pill position-relative">
                            <span class="flex-1 text-left text-truncate" [class.text-gray-900]="formStartTime" [class.text-gray-400]="!formStartTime">
                                {{ formStartTime ? formatTime(formStartTime) : 'Start' }}
                            </span>
                            <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                            <input type="text" readonly class="vf-time-overlay-input"
                                (focus)="onStartTimeFocus()" (blur)="hideStartTimeDropdown()">
                        </div>
                        <div *ngIf="showStartTimeDropdown" class="vf-time-options-dropdown">
                            <ng-container *ngFor="let t of timeOptions; let i = index">
                                <div *ngIf="getTimePeriodLabel(i)" class="vf-time-options-section">
                                    <div class="vf-time-options-section-line"></div>
                                    <span class="vf-time-options-section-label">{{ getTimePeriodLabel(i) }}</span>
                                    <div class="vf-time-options-section-line"></div>
                                </div>
                                <button type="button" class="vf-time-option" [class.active]="formStartTime === t"
                                    (mousedown)="selectStartTime(t)">{{ formatTime(t) }}</button>
                            </ng-container>
                        </div>
                    </div>
                    <span class="text-gray-300 flex-shrink-0 select-none f-size-12">&ndash;</span>
                    <!-- End time -->
                    <div class="flex-1 min-w-0 position-relative">
                        <div class="vf-time-pill position-relative">
                            <span class="flex-1 text-left text-truncate" [class.text-gray-900]="formEndTime" [class.text-gray-400]="!formEndTime">
                                {{ formEndTime ? formatTime(formEndTime) : 'End' }}
                            </span>
                            <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                            <input type="text" readonly class="vf-time-overlay-input"
                                (focus)="onEndTimeFocus()" (blur)="hideEndTimeDropdown()">
                        </div>
                        <div *ngIf="showEndTimeDropdown" class="vf-time-options-dropdown">
                            <ng-container *ngFor="let t of timeOptions; let i = index">
                                <div *ngIf="getTimePeriodLabel(i)" class="vf-time-options-section">
                                    <div class="vf-time-options-section-line"></div>
                                    <span class="vf-time-options-section-label">{{ getTimePeriodLabel(i) }}</span>
                                    <div class="vf-time-options-section-line"></div>
                                </div>
                                <button type="button" class="vf-time-option" [class.active]="formEndTime === t"
                                    (mousedown)="selectEndTime(t)">{{ formatTime(t) }}</button>
                            </ng-container>
                        </div>
                    </div>
                    <span class="f-size-12 text-gray-500 flex-shrink-0 text-right" style="min-width: 44px; font-variant-numeric: tabular-nums;">{{ formDurationDisplay }}</span>
                </div>

                <div *ngIf="formValidationError" class="px-16 pb-3 f-size-12 text-red-500">{{ formValidationError }}</div>
                <div *ngIf="!formValidationError && hasOverlap" class="px-16 pb-3 f-size-12 text-amber-600">This overlaps another time entry. Save anyway?</div>

                <!-- Actions -->
                <div class="d-flex align-items-center justify-content-end gap-8 px-16 pt-8 pb-12">
                    <button type="button" class="btn h-30 px-12 f-size-12 text-gray-500 hover:bg-gray-100 rounded-sm transition-colors border-0 bg-transparent"
                        (click)="cancelAdd()">Cancel</button>
                    <button type="button" class="btn h-30 px-12 f-size-12 font-weight-medium text-white bg-gray-900 hover:bg-gray-700 rounded-sm transition-colors border-0"
                        (click)="saveEntry()" [disabled]="!isFormValid || isSaving">
                        {{ isSaving ? 'Saving...' : (hasOverlap ? 'Save anyway' : 'Save') }}
                    </button>
                </div>
            </div>

            <!-- Delete confirmation -->
            <div *ngIf="confirmDeleteId !== null" class="d-flex align-items-center justify-content-between px-20 py-10 bg-red-50 flex-shrink-0" style="border-bottom: 1px solid #fecaca;">
                <span class="f-size-13 text-red-700">Delete this time entry?</span>
                <div class="d-flex gap-8">
                    <button class="btn p-0 f-size-13 text-gray-500 border-0 bg-transparent" (click)="cancelDelete()">Cancel</button>
                    <button class="btn h-30 px-12 f-size-13 font-weight-medium bg-red-600 text-white rounded-sm border-0" (click)="confirmDelete()" [disabled]="isDeleting">
                        {{ isDeleting ? 'Deleting...' : 'Delete' }}
                    </button>
                </div>
            </div>

            <!-- Empty state -->
            <div *ngIf="entries.length === 0 && !showAddForm" class="d-flex flex-column align-items-center justify-content-center py-48 px-24 text-center">
                <lucide-icon name="clock" [size]="32" class="text-gray-300 mb-12" [strokeWidth]="1.5"></lucide-icon>
                <p class="f-size-14 font-weight-medium text-gray-500 mb-3">No time logged yet</p>
                <p class="f-size-13 text-gray-400">Click "Add entry" to log time manually</p>
            </div>

            <!-- Entry groups -->
            <div *ngFor="let group of groups" class="vf-time-entry-group">

                <!-- Group header -->
                <div class="d-flex align-items-center justify-content-between px-16 py-8"
                    style="border-bottom: 1px solid rgb(229, 231, 235); background: rgb(243, 244, 246);">
                    <span class="f-size-12 text-gray-600">{{ group.label }}</span>
                    <span class="f-size-12 text-gray-500" style="font-variant-numeric: tabular-nums;">{{ group.total }}</span>
                </div>

                <!-- Entry rows -->
                <ng-container *ngFor="let entry of group.entries">

                    <!-- Inline edit form (date is implicit from the group) -->
                    <div *ngIf="editingEntryId === entry.id" class="vf-time-form" style="background: rgb(249, 250, 251); border-bottom: 1px solid rgb(229, 231, 235);">

                        <!-- Person picker -->
                        <div class="px-16 pt-12 pb-3">
                            <ng-container *ngTemplateOutlet="personPicker"></ng-container>
                        </div>

                        <!-- Time range -->
                        <div class="d-flex align-items-center gap-8 px-16 pb-3">
                            <div class="flex-1 min-w-0 position-relative">
                                <div class="vf-time-pill position-relative">
                                    <span class="flex-1 text-left text-truncate" [class.text-gray-900]="formStartTime" [class.text-gray-400]="!formStartTime">
                                        {{ formStartTime ? formatTime(formStartTime) : 'Start' }}
                                    </span>
                                    <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                                    <input type="text" readonly class="vf-time-overlay-input"
                                        (focus)="onStartTimeFocus()" (blur)="hideStartTimeDropdown()">
                                </div>
                                <div *ngIf="showStartTimeDropdown" class="vf-time-options-dropdown">
                                    <ng-container *ngFor="let t of timeOptions; let i = index">
                                        <div *ngIf="getTimePeriodLabel(i)" class="vf-time-options-section">
                                            <div class="vf-time-options-section-line"></div>
                                            <span class="vf-time-options-section-label">{{ getTimePeriodLabel(i) }}</span>
                                            <div class="vf-time-options-section-line"></div>
                                        </div>
                                        <button type="button" class="vf-time-option" [class.active]="formStartTime === t"
                                            (mousedown)="selectStartTime(t)">{{ formatTime(t) }}</button>
                                    </ng-container>
                                </div>
                            </div>
                            <span class="text-gray-300 flex-shrink-0 select-none f-size-12">&ndash;</span>
                            <div class="flex-1 min-w-0 position-relative">
                                <div class="vf-time-pill position-relative">
                                    <span class="flex-1 text-left text-truncate" [class.text-gray-900]="formEndTime" [class.text-gray-400]="!formEndTime">
                                        {{ formEndTime ? formatTime(formEndTime) : 'End' }}
                                    </span>
                                    <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                                    <input type="text" readonly class="vf-time-overlay-input"
                                        (focus)="onEndTimeFocus()" (blur)="hideEndTimeDropdown()">
                                </div>
                                <div *ngIf="showEndTimeDropdown" class="vf-time-options-dropdown">
                                    <ng-container *ngFor="let t of timeOptions; let i = index">
                                        <div *ngIf="getTimePeriodLabel(i)" class="vf-time-options-section">
                                            <div class="vf-time-options-section-line"></div>
                                            <span class="vf-time-options-section-label">{{ getTimePeriodLabel(i) }}</span>
                                            <div class="vf-time-options-section-line"></div>
                                        </div>
                                        <button type="button" class="vf-time-option" [class.active]="formEndTime === t"
                                            (mousedown)="selectEndTime(t)">{{ formatTime(t) }}</button>
                                    </ng-container>
                                </div>
                            </div>
                            <span class="f-size-12 text-gray-500 flex-shrink-0 text-right" style="min-width: 44px; font-variant-numeric: tabular-nums;">{{ formDurationDisplay }}</span>
                        </div>

                        <div *ngIf="formValidationError" class="px-16 pb-3 f-size-12 text-red-500">{{ formValidationError }}</div>
                        <div *ngIf="!formValidationError && hasOverlap" class="px-16 pb-3 f-size-12 text-amber-600">This overlaps another time entry. Save anyway?</div>

                        <!-- Actions -->
                        <div class="d-flex align-items-center justify-content-end gap-8 px-16 pt-8 pb-12">
                            <button type="button" class="btn h-30 px-12 f-size-12 text-gray-500 hover:bg-gray-100 rounded-sm transition-colors border-0 bg-transparent"
                                (click)="cancelEdit()">Cancel</button>
                            <button type="button" class="btn h-30 px-12 f-size-12 font-weight-medium text-white bg-gray-900 hover:bg-gray-700 rounded-sm transition-colors border-0"
                                (click)="saveEntry()" [disabled]="!isFormValid || isSaving">
                                {{ isSaving ? 'Saving...' : (hasOverlap ? 'Save anyway' : 'Save') }}
                            </button>
                        </div>
                    </div>

                    <!-- Normal row -->
                    <div *ngIf="editingEntryId !== entry.id"
                        class="px-16 py-12 d-flex align-items-center gap-12 hover:bg-gray-50 transition-colors"
                        style="border-bottom: 1px solid rgb(243, 244, 246);">
                        <div class="d-flex align-items-center gap-8 flex-shrink-0" style="min-width: 108px;">
                            <div class="rounded-full bg-gray-200 text-gray-600 d-flex align-items-center justify-content-center flex-shrink-0 overflow-hidden"
                                style="width: 24px; height: 24px; font-size: 10px;">
                                <img *ngIf="entry.userAvatarUrl" [src]="entry.userAvatarUrl" [alt]="entry.userName" class="w-100 h-100" style="object-fit: cover;">
                                <span *ngIf="!entry.userAvatarUrl">{{ entry.userInitials || getInitials(entry.userName) }}</span>
                            </div>
                            <span class="f-size-14 text-gray-700 text-truncate line-height-normal">{{ entry.userName }}</span>
                        </div>
                        <span class="f-size-12 text-gray-500 flex-1 min-w-0" style="font-variant-numeric: tabular-nums;">{{ formatTime(entry.startTime) }} &ndash; {{ formatTime(entry.endTime) }}</span>
                        <span class="f-size-14 text-gray-700 flex-shrink-0" style="font-variant-numeric: tabular-nums;">{{ ttService.formatDuration(entry.durationSeconds) }}</span>
                        <div class="dropdown flex-shrink-0 position-relative" *ngIf="canManageEntry(entry)">
                            <button type="button"
                                class="btn p-0 d-flex align-items-center justify-content-center rounded-sm text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors border-0"
                                style="width: 24px; height: 24px; background: transparent;"
                                data-toggle="dropdown">
                                <lucide-icon name="ellipsis" [size]="14" [strokeWidth]="2"></lucide-icon>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                                <a class="dropdown-item d-flex" href="javascript:;" (click)="editEntry(entry)">
                                    <lucide-icon name="pencil" [size]="16" [strokeWidth]="2" class="mr-1 no-fill text-gray-400"></lucide-icon>
                                    <span class="text-none">Edit</span>
                                </a>
                                <div role="separator" style="height: 1px; margin-inline: -4px; margin-block: 1px; background-color: #0000001a !important;"></div>
                                <a class="dropdown-item d-flex hover:bg-red-50" href="javascript:;" (click)="requestDelete(entry.id)">
                                    <lucide-icon name="trash-2" [size]="16" [strokeWidth]="2" class="mr-1 no-fill text-red-400"></lucide-icon>
                                    <span class="text-none text-red-600">Delete</span>
                                </a>
                            </div>
                        </div>
                    </div>

                </ng-container>
            </div>

        </ng-container>
    </div>
</div>

<!-- Person picker (assignee-style dropdown, shared between add & edit forms) -->
<ng-template #personPicker>
    <div class="dropdown vf-time-person-drop position-relative w-100"
        (shown.bs.dropdown)="onOpenPersonDropdown()">
        <div class="vf-time-pill" data-toggle="dropdown" role="button" tabindex="0"
            aria-haspopup="true" aria-expanded="false">
            <ng-container *ngIf="!formPersonId">
                <lucide-icon name="users" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                <span class="flex-1 text-left text-gray-400 f-size-13">Select person</span>
                <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
            </ng-container>
            <ng-container *ngIf="formPersonId">
                <span class="rounded-full bg-gray-200 text-gray-600 d-flex align-items-center justify-content-center flex-shrink-0 overflow-hidden"
                    style="width: 20px; height: 20px; font-size: 10px;">
                    <img *ngIf="formPersonAvatarUrl" [src]="formPersonAvatarUrl" [alt]="formPersonName" class="w-100 h-100" style="object-fit: cover;">
                    <span *ngIf="!formPersonAvatarUrl">{{ getInitials(formPersonName) }}</span>
                </span>
                <span class="flex-1 text-left text-truncate text-gray-800 f-size-13">{{ formPersonName }}</span>
                <span class="d-inline-flex align-items-center justify-content-center text-gray-300 hover:text-gray-600 transition-colors cursor-pointer flex-shrink-0"
                    (click)="clearPerson(); $event.stopPropagation();">
                    <lucide-icon name="x" [size]="14" [strokeWidth]="2"></lucide-icon>
                </span>
            </ng-container>
        </div>
        <div class="dropdown-menu rounded-8 p-0 w-100" (click)="$event.stopPropagation()">
            <div class="position-relative" style="border-bottom: 1px solid rgb(229, 231, 235);">
                <lucide-icon name="search" [size]="14" [strokeWidth]="2" class="text-gray-400 position-absolute"
                    style="top: 50%; left: 12px; transform: translateY(-50%);"></lucide-icon>
                <input type="text" placeholder="Search person" autocomplete="off"
                    class="form-control border-0 f-size-13 w-100"
                    style="padding-left: 32px; height: 36px; outline: none !important; box-shadow: none !important; background: transparent; border-radius: 0;"
                    [(ngModel)]="personSearchText" name="personSearchText"
                    (input)="onPersonSearchInput()">
            </div>
            <div *ngIf="!isLoadingMembers && !personSearchText && visibleMembers.length > 0"
                style="padding: 10px 12px 4px 12px;">
                <span class="f-size-11 text-gray-500 font-weight-medium">Recent</span>
            </div>
            <img *ngIf="isLoadingMembers" src="https://cdn.trovve.com/vfapp/images/loading-dots.gif"
                class="data-loading mx-auto d-block my-2" style="height: 14px;">
            <div style="max-height: 260px; overflow-y: auto;" *ngIf="!isLoadingMembers">
                <button *ngFor="let member of visibleMembers" type="button"
                    class="d-flex align-items-center gap-8 w-100 btn rounded-0 text-left transition-colors hover:bg-gray-50"
                    style="padding: 8px 12px;"
                    (click)="selectPerson(member)">
                    <span class="rounded-full bg-gray-200 text-gray-600 d-flex align-items-center justify-content-center flex-shrink-0 overflow-hidden"
                        style="width: 24px; height: 24px; font-size: 10px;">
                        <img *ngIf="member.profilePictureUrl" [src]="member.profilePictureUrl" [alt]="member.memberName" class="w-100 h-100" style="object-fit: cover;">
                        <span *ngIf="!member.profilePictureUrl">{{ getInitials(member.memberName) }}</span>
                    </span>
                    <span class="f-size-13 flex-1 text-truncate text-gray-900">{{ member.memberName }}</span>
                </button>
                <div *ngIf="visibleMembers.length === 0" class="text-center f-size-12 text-gray-400" style="padding: 16px 12px;">
                    No users found
                </div>
            </div>
        </div>
    </div>
</ng-template>
